import type { DataDictionaryItem, DisplayThemeWithSDG } from '@netpurpose/api'

export const mapQuestionsToThemes = (
  themes: DisplayThemeWithSDG[],
  questions: DataDictionaryItem[],
) =>
  themes.reduce(
    (acc, theme) => ({
      ...acc,
      [theme]: questions.filter((question) => question.displayThemes.includes(theme)),
    }),
    {} as Record<DisplayThemeWithSDG, DataDictionaryItem[]>,
  )
